<template>
  <v-dialog :value="value" width="400px" persistent>
    <v-card>
      <v-card-title class="headline">Clear Email History</v-card-title>
      <v-card-text class="black--text">
        <p>Are you sure you want to clear the email history?</p>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text depressed small @click="close">Close</v-btn>
        <v-btn color="error" text depressed small @click="clearHistory">Clear History</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, required: true },
    onClear: { type: Function, required: true },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    clearHistory() {
      this.$emit("input", false);
      this.onClear();
    },
  },
};
</script>
